/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import EventEffectSequence from '../Effects/EventEffectSequence';
import ComponentBase from '../Utility/ComponentBase';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import Reel from './Reel';

/** Wrangles the components and effects that constitute a [[Reel]]. */
@cc._decorator.ccclass
export default class ReelContents extends ComponentBase
{
    /** The associated [[Reel]]. */
    private _reel: Reel = null;
    /** The effects associated with this reel. */
    private _reelEffects: EventEffectSequence[] = [];

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.configureDependencies();
    }

    /** @hidden */
    private configureDependencies(): void
    {
        this._reel = this.getFirstParent(Reel);

        if (!this._reel)
        {
            CLog.error("No reelManager configured.", this, LogTypes.Reel);
            this.enabled = false;
            return;
        }
    }
}
